import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, pricing } from '../data/bonuses';
import { BonusCard } from './BonusCard';
export function Bonuses() {
  return <section id="bonuses" className="bg-brand px-4 py-12 md:py-16" data-id="element-31" data-mp="av36mvbir927">
      <div className="mx-auto max-w-3xl text-center" data-id="element-32" data-mp="auteb1304ptc">
        <GiftIcon className="mx-auto h-8 w-8 text-gold-light" aria-hidden="true" data-id="element-33" data-mp="ftmr0ragscsg" />
        <h2 className="mt-3 text-2xl font-black uppercase leading-tight text-white md:text-4xl" data-id="element-34" data-mp="1un4pqafc9zg">
          Includes <span className="text-gold-light" data-id="element-35" data-mp="5vqhu5137rwz">5 practical bonuses</span>
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-4" data-id="element-36" data-mp="3o1v6yjq1s0r9">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-37" data-mp="3t0ogy264l9mo" />)}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-gold-light p-5 text-center" data-id="element-38" data-mp="3t0yb81y7e2y6">
          <p className="text-[11px] font-extrabold uppercase tracking-wider text-white/85" data-id="element-39" data-mp="1r9329u3c0cjn">
            Total reference value of the 5 bonuses
          </p>
          <span className="mt-1 text-3xl font-black text-white/85 line-through decoration-red-500 decoration-4" data-id="element-40" data-mp="3iclndrr6aixt">
            ${pricing.bonusValue} USD
          </span>
          <p className="mt-1 text-lg font-black uppercase text-gold-light" data-id="element-41" data-mp="3r5ouzjf501kj">All 5 bonuses included free</p>
        </div>
      </div>
    </section>;
}